import React, { Component } from "react";
import Observer from "@researchgate/react-intersection-observer";

class NeedsIntersection extends Component {
  state = {
    intersecting: false
  };

  handleChange = (entry, unobserve) => {
    if (!entry.isIntersecting) return;

    this.setState({ intersecting: true });
    unobserve();
  };

  render() {
    return (
      <Observer onChange={this.handleChange}>
        <div>{this.state.intersecting && this.props.children}</div>
      </Observer>
    );
  }
}

export default NeedsIntersection;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/NeedsIntersection.js